import {apiBase} from 'api/base.js';

const EartagAnalyzerAPI = {
  retry: (params) => {
    return apiBase.request('/admin/eartag_analyzer/retry', 'POST', params);
  },

  retryAllFarms: (params) => {
    return apiBase.request('/admin/eartag_analyzer/retry_all_farms', 'POST', params);
  }
};

export {EartagAnalyzerAPI as eartagAnalyzerAPI};
